import './src/assets/styles/global.css';

export const onClientEntry = () => {
	try {
		const searchParams = window.location.search;
		console.log('[Early Capture] Search params:', searchParams);
		if (searchParams) {
			const urlParams = new URLSearchParams(searchParams);
			const qParam = urlParams.get('q');
			if (qParam) {
				sessionStorage.setItem('earlyQueryParam', qParam);
				console.log('[Early Capture] Found query param q=', qParam);
			}
		}
	} catch (e) {
		console.error('[Early Capture] Error:', e);
	}
};
